import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {Link} from "react-router-dom";
import styled from "styled-components";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {useHistory} from "react-router-dom";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {updateDocumentTitle} from "../../Utils/Common";
import {ReasonCaptureModal} from "../Common/ReasonCaptureModal";
import PageLayout from "../Layout/PageLayout";
import {Button, Card, CardTitleBar, CardBody, FormField, TextInput, Select, StatusBadge, Spinner} from "../UI";
import {tokens} from "../../theme/tokens";

const InfoTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    td {
        padding: ${tokens.spacing[3]} ${tokens.spacing[4]};
        font-size: ${tokens.typography.size.base};
        border-bottom: 1px solid ${tokens.colors.divider};
        vertical-align: middle;
    }
    td:first-child { color: ${tokens.colors.muted}; width: 45%; }
    td:last-child { color: ${tokens.colors.heading}; font-weight: ${tokens.typography.weight.semibold}; }
    tr:last-child td { border-bottom: 0; }
`;

const RequestTypeDetails = props => {
    let history = useHistory();
    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState({title: ''});
    const [pendingAction, setPendingAction] = useState(null);
    const [pendingUpdate, setPendingUpdate] = useState(false);
    const [description, setDescription] = useState('');
    const [name, setName] = useState('');
    const [requestTypeTime, setRequestTypeTime] = useState('');
    const [requestTypeStatus, setRequestTypeStatus] = useState(1);

    const {id} = props.match.params;

    const load = () => {
        let data = new FormData();
        data.append("id", id);

        setIsLoading(true);
        postData(Endpoints.REQUEST_TYPE_FIND, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setItem(res.data);
                    setName(res.data.name);
                    setDescription(res.data.description);
                    setRequestTypeStatus(res.data.can_be_handed_over ? 1 : 0)
                    setRequestTypeTime(res.data.expected_time)
                    updateDocumentTitle(res.data.name)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };

    useEffect(() => {
        load()
    }, []);

    function updateStatus(number, reason) {
        let data = new FormData();
        data.append("id", id);
        data.append("status", number);
        data.append("reason", reason);

        setIsLoading(true);
        postData(Endpoints.REQUEST_TYPE_UPDATE_STATUS, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    load()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function updateDetails(e, reason) {
        if (e) e.preventDefault()

        let data = new FormData();
        data.append("id", id)
        data.append("name", name)
        data.append("description", description)
        data.append("expected_time", requestTypeTime)
        data.append("status", requestTypeStatus)
        data.append("reason", reason)

        setIsLoading(true)
        postData(Endpoints.REQUEST_TYPE_UPDATE_DETAILS, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    load()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function deleteMeansType() {
        let data = new FormData();
        data.append("id", id);

        setIsLoading(true)
        postData(Endpoints.MEANS_TYPE_DELETE, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? res.data : res.data, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    load()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    return (
        <PageLayout
            title={item.name}
            actions={item.title !== '' ? (
                <div style={{display: "flex", alignItems: "center", gap: tokens.spacing[2]}}>
                    {isLoading && <Spinner size={18}/>}
                    {!isLoading &&
                    <Button
                        variant={item.status === 1 ? "danger" : "primary"}
                        onClick={e => setPendingAction(item.status === 1 ? 0 : 1)}>
                        {item.status === 1 ? "Deactivate" : "Activate"}
                    </Button>
                    }
                    <Link to={"/areas/" + item.area_id}>
                        <Button variant="outline">Back to area details</Button>
                    </Link>
                </div>
            ) : null}
        >
            {item.title !== '' &&
            <div className="row">
                <div className="col-md-6">
                    <Card padded>
                        <InfoTable>
                            <tbody>
                            <tr>
                                <td>Name</td>
                                <td>{item.name}</td>
                            </tr>
                            <tr>
                                <td>Description</td>
                                <td>{item.description}</td>
                            </tr>
                            <tr>
                                <td>Expected Time</td>
                                <td>{item.expected_time}</td>
                            </tr>
                            <tr>
                                <td>Mode</td>
                                <td>{item.can_be_handed_over ? "Standard" : "Express"}</td>
                            </tr>
                            <tr>
                                <td>Status</td>
                                <td>
                                    <StatusBadge tone={item.status === 0 ? "neutral" : "success"}>
                                        {item.status === 0 ? "INACTIVE" : "ACTIVE"}
                                    </StatusBadge>
                                </td>
                            </tr>
                            </tbody>
                        </InfoTable>
                    </Card>
                </div>
                <div className="col-md-6">
                    <Card padded={false}>
                        <CardTitleBar title="Update"/>
                        <CardBody>
                            <form onSubmit={e => { e.preventDefault(); setPendingUpdate(true); }}>

                                <FormField label="Name" required htmlFor="requestName">
                                    <TextInput id="requestName"
                                               type="text"
                                               required={true}
                                               placeholder="Name"
                                               value={name}
                                               onChange={e => setName(e.target.value)}
                                    />
                                </FormField>

                                <FormField label="Description" required htmlFor="requestDescription">
                                    <TextInput id="requestDescription"
                                               type="text"
                                               required={true}
                                               placeholder="Description"
                                               value={description}
                                               onChange={e => setDescription(e.target.value)}
                                    />
                                </FormField>

                                <FormField label="Expected duration in hours" required htmlFor="requestTime">
                                    <TextInput id="requestTime"
                                               type="number"
                                               required={true}
                                               value={requestTypeTime}
                                               onChange={e => setRequestTypeTime(e.target.value)}
                                    />
                                </FormField>

                                <FormField label="Select a mode" htmlFor="requestMode">
                                    <Select id="requestMode"
                                            value={requestTypeStatus}
                                            onChange={({target}) => setRequestTypeStatus(target.value)}>
                                        <option value={1}>Standard mode - Riders can hand over requests
                                            to each other
                                        </option>
                                        <option value={0}>Express mode - Only one rider is allowed to
                                            handle each request
                                        </option>
                                    </Select>
                                </FormField>

                                <Button type="submit" loading={isLoading}>Update</Button>

                            </form>
                        </CardBody>
                    </Card>
                </div>
            </div>
            }
            {pendingAction !== null &&
            <ReasonCaptureModal
                title={pendingAction === 0 ? "Deactivate request type" : "Activate request type"}
                onCancel={() => setPendingAction(null)}
                onConfirm={reason => { updateStatus(pendingAction, reason); setPendingAction(null); }}
            />
            }
            {pendingUpdate &&
            <ReasonCaptureModal
                title="Update request type details"
                onCancel={() => setPendingUpdate(false)}
                onConfirm={reason => { updateDetails(null, reason); setPendingUpdate(false); }}
            />
            }
        </PageLayout>
    )
};


export default RequestTypeDetails
